import api from "@/modules/common/api";
import * as consts from "./consts";
import differenceBy from "@/utils/differenceBy";

const initialState = {
  points: [],
  selectedPoints: []
};

const actions = {
  async initialize({ commit, rootState }) {
    const { data } = await api.getPoints(rootState.common.source);
    commit(consts.SET_POINTS, data);
    commit(consts.SET_SELECTED_POINTS, []);
  },
  selectPoints({ commit, state }, points) {
    points = state.selectedPoints.concat(points);
    points.sort((a, b) => {
      if (a.name > b.name) {
        return 1;
      }

      if (a.name < b.name) {
        return -1;
      }

      return 0;
    });

    commit(consts.SET_SELECTED_POINTS, points);
  },
  deselectPoints({ commit, state }, points) {
    points = differenceBy(state.selectedPoints, points, "id");

    commit(consts.SET_SELECTED_POINTS, points);
  }
};

const mutations = {
  [consts.SET_POINTS](state, points) {
    state.points = points;
  },
  [consts.SET_SELECTED_POINTS](state, points) {
    state.selectedPoints = points;
  }
};

const getters = {
  availablePoints({ points, selectedPoints }) {
    return differenceBy(points, selectedPoints, "id");
  }
};
export default {
  namespaced: true,
  state: initialState,
  actions,
  mutations,
  getters
};
